export default {
  title: '营销活动',
  activityManagement: '活动管理',
  activityList: '活动列表',
  drawRecord: '开奖记录',
  giftClaimRecord: '礼品领取记录',
  activityTemplate: '活动模板',
  marketingData: '营销数据',
};
